<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <b-form>
          <b-form-group
            label="Nombre:"
            label-for="nombre"
            :label-cols="4"
            horizontal>
            <b-form-input 
              id="nombre" 
              v-model= "nombre" 
              type="text">
            </b-form-input>
          </b-form-group>
        </b-form>
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-table hover  
            responsive="sm" 
            class="registro"
            :busy="tableBusy"
            :items="jurisdicciones" 
            :fields="jurisdiccionesFields"
            :filter="nombre"
            :current-page="paginaActual"
            :per-page="registrosPorPagina"
            @filtered="onFiltered"
            @row-clicked="seleccionarJurisdiccion">
          <div slot="table-busy" class="text-center">
            <b-spinner class="table-spinner" label="Spinning" />
          </div>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="12">  
        <nav>
          <b-pagination size="sm" 
            :total-rows="totalRegistros" 
            :per-page="registrosPorPagina" 
            v-model="paginaActual" 
            prev-text="Prev." next-text="Prox."/>
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: 'JurisdiccionesIngresosBrutosSearch',
  data: () => {
    return {
      jurisdicciones: [],
      jurisdiccionesFields: [
        // {
        //   key: 'id',
        //   label: 'Cód.'
        // },
        {
          key: 'nombre',
          label: 'Jurisdiccion',
          sortable: true
        },
      ],

      loaded: false,
      tableBusy: false,

      /* Info de paginación */
      paginaActual: 1,
      totalPaginas: 1,
      registrosPorPagina: 5,
      totalRegistros: 0,

      nombre: null,
    }
  },
  computed: {
  },
  created() {
    this.getJurisdicciones();
  },  
  methods: {
    getJurisdicciones() {
      this.tableBusy = true;
      this.$store.dispatch('jurisdiccionesIngresosBrutos/getList')
        .then(() => {
          this.jurisdicciones = this.$store.getters['jurisdiccionesIngresosBrutos/list'];
          this.totalRegistros = this.provincias.length;
          this.tableBusy = false;
        })
    },
    seleccionarJurisdiccion (item) {
      this.$emit('jurisdiccionSeleccionada', item)
    },
    onFiltered(filteredItems) {
      this.totalRegistros = filteredItems.length
      this.paginaActual = 1
    }    
  },
}
</script>

<style>
</style>
